import {
  BookOutlined,
  DashboardOutlined,
  AreaChartOutlined
  
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import materiaIcono from '../menus/icons/materiaIcono.js'

//MODULOS
import AdminModuloUsuarios from './modulos/m_usuarios.js'
import AdminModuloEstructura from './modulos/m_estructura.js';
import AdminModuloAcademica from './modulos/m_academica.js';
import AdminModuloConfiguracion from './modulos/m_configuracion.js';
import AdminModuloAyuda from './modulos/m_ayuda.js';
import ModuloComunicacion from './modulos/m_comunicacion.js';
import AdminModuloFinanzas from './modulos/m_finanzas.js';
import AdminModuloEcommerce from './modulos/m_ecommerce.js';
import AdminSecModuloUsuarios from './modulos/m_sec_usuarios.js';

let dataEscuela = JSON.parse(localStorage.getItem('dataEscuela'));
const admins = [{
  key: 'Admin',
  path: `${APP_PREFIX_PATH}/admin`,
  title: 'sidenav.admin.admin',
  icon: BookOutlined,
  breadcrumb: true,
  permission:['show'],
  submenu: [
    {
      key: 'Dashboard',
      path: `${APP_PREFIX_PATH}/admin/dashboard`,
      title: 'sidenav.admin.dashboard',
      icon: DashboardOutlined,
      breadcrumb: true,
      permission:['show'],
      submenu: [
      ]
    },
    {
      key: 'Asignaturas',
      path: `${APP_PREFIX_PATH}/cursos/list`,
      title: 'sidenav.admin.asignaturas',
      icon: materiaIcono,
      breadcrumb: false,
      permission:['Read:cursos'],
      submenu: [
      ]
    },
    ...AdminModuloUsuarios,
    ...AdminModuloEstructura,
    ...AdminModuloAcademica,
    {
      key: 'Stats',
      path: `${APP_PREFIX_PATH}/admin/informes`,
      title: 'sidenav.admin.report',
      icon: AreaChartOutlined,
      breadcrumb: true,
      permission:['show'],
      submenu: [
      ]
    },
    ...AdminModuloConfiguracion,
    ...AdminModuloAyuda,
  ]
}]


const adminsSecciones = [{
  key: 'Admin',
  path: `${APP_PREFIX_PATH}/admin`,
  title: 'sidenav.admin.admin',
  icon: BookOutlined,
  breadcrumb: true,
  submenu: [
    {
      key: 'Dashboard',
      path: `${APP_PREFIX_PATH}/admin/dashboard`,
      title: 'sidenav.admin.dashboard',
      icon: DashboardOutlined,
      breadcrumb: true,
      permission:['show'],
      submenu: [
      ]
    },
    {
      key: 'Asignaturas',
      path: `${APP_PREFIX_PATH}/cursos/list`,
      title: 'sidenav.admin.asignaturas',
      icon: materiaIcono,
      breadcrumb: false,
      permission:['Read:cursos'],
      submenu: [
      ]
    },
    ...AdminModuloUsuarios,
    ...AdminModuloEstructura,
    ...AdminModuloAcademica,
    ...AdminModuloAyuda,
  ]
}]

const navigationConfig = [
  {
    director: [...admins, ...ModuloComunicacion],
    // alumnos: [...admins, ...Comunicacion],
    // profesor: [...admins, ...ModuloComunicacion],
    adminSeccion:[...adminsSecciones,...ModuloComunicacion]
  }
]

let parametros = dataEscuela?.parametros;
if(parametros?.eCommerce){navigationConfig[0]['director'] = [
  ...admins, 
  ...AdminModuloFinanzas,
  ...AdminModuloEcommerce, 
  ...ModuloComunicacion
]}


export default navigationConfig;
